<template>
    <div class="search-box">
        <div class="spacer"></div>
        <form @submit.prevent="submit" v-if="user">
            <input type="search" name="search" placeholder="" v-model="searchtext" />
            <button>Search</button>
        </form>
    </div>
</template>
<script>
import axios from 'axios'
import {mapState} from 'vuex'
// import debounce from 'lodash-es/debounce'

export default {
    name: 'SearchBox',
    data() {
        return {
            searchtext: '',
        }
    },
    computed: {
        ...mapState(['user']),
    },
    methods: {
        async submit() {
            this.$store.dispatch('search', this.searchtext)
            this.$router.push('/search-results')
        }
    },
}
</script>
<style lang="scss">
@import '../scss/include-media';

.search-box {
    margin: 0 auto;
    max-width: 95vw;

    padding: 50px 75px;

    @include media('<tablet') {
        padding: 25px;
    }
    @include media('>=tablet') {
        padding: 25px;
    }


    display: grid;
    grid-template-areas: 's form';
    grid-template-columns: 3fr 1fr;

    .spacer {
        grid-area: s;
    }
    form {
        grid-area: form;

        display: flex;
        flex-flow: row nowrap;

        input {

        }
        button {
            padding: 0.5rem 1.25rem;
            flex: 1 0 auto;

            @supports (display: grid) {
                flex: 0 1 auto;
            }
        }
    }
}

</style>
